import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Facebook, Instagram, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1a2332] text-gray-300" data-id="element-1202">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-1203">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-1204">
          {/* Brand Section */}
          <div className="lg:col-span-1" data-id="element-1205">
            <Link to="/" className="inline-block mb-6" data-id="element-1206">
              <img src="https://cdn.magicpatterns.com/uploads/7EjErFNEa8ZC1es35aEHqt/RENTA_logo.png" alt="Renta" className="h-10 w-auto brightness-0 invert" data-id="element-1207" />
            </Link>
            <p className="text-gray-400 leading-relaxed mb-6" data-id="element-1208">
              Nigeria's first financier-backed rent platform. Transforming the
              rental experience for everyone.
            </p>
          </div>

          {/* Platform Links */}
          <div data-id="element-1209">
            <h4 className="text-white font-bold text-lg mb-6" data-id="element-1210">PLATFORM</h4>
            <ul className="space-y-4" data-id="element-1211">
              <li data-id="element-1212">
                <Link to="/signup" className="text-gray-400 hover:text-white transition-colors" data-id="element-1213">
                  For Renters
                </Link>
              </li>
              <li data-id="element-1214">
                <Link to="/signup" className="text-gray-400 hover:text-white transition-colors" data-id="element-1215">
                  For Financiers
                </Link>
              </li>
              <li data-id="element-1216">
                <Link to="/signup" className="text-gray-400 hover:text-white transition-colors" data-id="element-1217">
                  For Landlords
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div data-id="element-1218">
            <h4 className="text-white font-bold text-lg mb-6" data-id="element-1219">COMPANY</h4>
            <ul className="space-y-4" data-id="element-1220">
              <li data-id="element-1221">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-1222">
                  About Us
                </a>
              </li>
              <li data-id="element-1223">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-1224">
                  Careers
                </a>
              </li>
              <li data-id="element-1225">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-1226">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div data-id="element-1227">
            <h4 className="text-white font-bold text-lg mb-6" data-id="element-1228">LEGAL</h4>
            <ul className="space-y-4" data-id="element-1229">
              <li data-id="element-1230">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-1231">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-1232">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-1233">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-1234">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-1235">
                  NDPR Compliant
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-1236">
          {/* Copyright */}
          <p className="text-gray-500 text-sm" data-id="element-1237">
            © 2026 Renta. All rights reserved.
          </p>

          {/* Social Links */}
          <div className="flex items-center gap-4" data-id="element-1238">
            <a href="#" className="w-10 h-10 rounded-full bg-gray-700/50 hover:bg-gray-600 flex items-center justify-center transition-colors" aria-label="Twitter" data-id="element-1239">
              <Twitter className="h-5 w-5" data-id="element-1240" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-gray-700/50 hover:bg-gray-600 flex items-center justify-center transition-colors" aria-label="Facebook" data-id="element-1241">
              <Facebook className="h-5 w-5" data-id="element-1242" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-gray-700/50 hover:bg-gray-600 flex items-center justify-center transition-colors" aria-label="Instagram" data-id="element-1243">
              <Instagram className="h-5 w-5" data-id="element-1244" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-gray-700/50 hover:bg-gray-600 flex items-center justify-center transition-colors" aria-label="LinkedIn" data-id="element-1245">
              <Linkedin className="h-5 w-5" data-id="element-1246" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}